<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useSetLanguage } from './api';

const { locale, availableLocales } = useI18n();

const { mutate: updateLanguage } = useSetLanguage({
  onSuccess: () => {
    location.reload();
  }
});

</script>

<template>
  <div class="overflow-auto text-white max-h-80">
    <ul class="w-full">
      <li
        v-for="language in availableLocales"
        :key="language"
        class="p-3 cursor-pointer hover:bg-gray-700"
        :class="{ 'bg-blue-500 hover:bg-blue-400': language === locale }"
        @click="updateLanguage(language)"
      >
        {{ $t(`language.${language}`) }}
      </li>
    </ul>
  </div>
</template>
